// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1yJQQ","buttons":"PendingPaymentAlert_buttons__cocnK"};